import { DynamicRouterPath } from '../../dynamic-router-path';
import { RouterPath } from '../../router-path';
export var responderAppPath = {
  dashboard: RouterPath.create('/bricks?menu=assignment&level=1'),
  callback: DynamicRouterPath.createWithDynamic(function (id) {
    return RouterPath.create("/callback/".concat(id));
  }, '/callback/[accessId]'),
  assignment: {
    list: RouterPath.create('/bricks?menu=assignment&level=1'),
    detail: DynamicRouterPath.createWithDynamic(function (id) {
      return RouterPath.create("/bricks/assignment/".concat(id));
    }, '/bricks/assignment/[id]')
  },
  submission: {
    detail: DynamicRouterPath.createWithDynamic(function (id) {
      return RouterPath.create("/submission/".concat(id));
    }, '/submission/[id]'),
    preview: {
      "default": DynamicRouterPath.createWithDynamic(function (id) {
        return RouterPath.create("/submission/preview/".concat(id));
      }, '/submission/preview/[id]'),
      examination: DynamicRouterPath.createWithDynamic(function (id) {
        return RouterPath.create("/submission/preview/examination/".concat(id));
      }, '/submission/preview/examination/[submissionId]')
    },
    submit: DynamicRouterPath.createWithDynamic(function (id) {
      return RouterPath.create("/submission/submit/".concat(id));
    }, '/submission/submit/[id]')
  }
};